import { DiContainer } from '@/modules/di/di-container';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { BusinessOffersService } from '../services/business-offers.service';
import { IIncomingOffer } from '../types/business-offer';

const businessOffersService = DiContainer.get(BusinessOffersService);
export const setSpecificOffersGroup = createEvent();
export const $specificTradeOffersGroup = createStore<{ offers: IIncomingOffer[], buyer: { name: string, type: string }} | null>(null).on(
  setSpecificOffersGroup,
  (_s, p) => p,
);
export const $specificTradeOffersGroupLoadingStatus = createStore<{
  loading: boolean;
  error: boolean | Error;
}>({ loading: false, error: false });
const setSpecificTradeOfferLoadingStatus = createEvent<{
  loading: boolean;
  error: boolean | Error;
}>();
$specificTradeOffersGroupLoadingStatus.on(
  setSpecificTradeOfferLoadingStatus,
  (_S, p) => p,
);

export const fetchSpecificTradeOffersGroupDataFx = createEffect(
  async ({
    buyerable_id,
    buyerable_type,
  }: {
    buyerable_id: number;
    buyerable_type: string;
  }) => {
    try {
      setSpecificTradeOfferLoadingStatus({ loading: true, error: false });
      const res: any = await businessOffersService.getOffersGroup(
        buyerable_id,
        buyerable_type,
      );
      const buyer = res.buyer;
      delete res.buyer;

      const offers = Object.values(res);
      setSpecificTradeOfferLoadingStatus({ loading: false, error: false });
      return { buyer, offers };
    } catch (err) {
      setSpecificTradeOfferLoadingStatus({ loading: true, error: err as Error });
    }
  },
);

sample({
  target: setSpecificOffersGroup,
  clock: fetchSpecificTradeOffersGroupDataFx.doneData,
});
